import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from 'dayjs';
export default function MemberDOB(props) {
    const [value, setValue] = React.useState(props.date ? getDateFormat(props.date) : null);
    useEffect(() => {
        props.date &&
            getDateFormat(props.date) !== value &&
            setValue(getDateFormat(props.date));
    }, [props.date]);
    return (React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
        React.createElement(MobileDatePicker, { disabled: props.disabled, label: "Date of Service *", value: value, closeOnSelect: false, 
            // showToolbar={false}
            maxDate: dayjs(new Date()), onChange: (newValue, key) => {
                const serviceDate = getDateFormat(newValue);
                setValue(serviceDate);
            }, onClose: () => {
                props.updateSelectedMember("serviceDate", value || new Date());
            }, renderInput: (params) => React.createElement(TextField, Object.assign({ variant: "filled" }, params)) })));
}
const getDateFormat = (date) => {
    let serviceDate = new Date(date);
    serviceDate = `${serviceDate.getFullYear()}-${serviceDate.getMonth() + 1 < 10
        ? "0" + (serviceDate.getMonth() + 1)
        : serviceDate.getMonth() + 1}-${serviceDate.getDate() < 10
        ? "0" + serviceDate.getDate()
        : serviceDate.getDate()}`;
    return serviceDate;
};
